import { Review } from '@fable/types'
import { BookDetailReviewContent } from './BookDetailReviewContent'
import { BookDetailReviewHeader } from './BookDetailReviewHeader'

export const BookDetailReview = ({
  review,
  mini = false,
}: {
  review: Review
  mini?: boolean
}) => (
  <div>
    <BookDetailReviewHeader review={review} mini={mini} />
    <BookDetailReviewContent review={review} />
  </div>
)
